// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './action-type.model';
export * from './action.model';
export * from './business-type.model';
export * from './opportunity.model';
export * from './prospect-sheet.model';
// @endindex